exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-15-wrapper[data-v-f198d1e4]{width:180px;padding-bottom:10px}.listing-img[data-v-f198d1e4]{width:70px;height:70px;border-radius:50%}", ""]);

// exports
